export default "__VITE_ASSET__DuIX9C3h__"